import axios from "axios";
import {
  FetchStoryboardsRequest,
  FetchStoryboardsResponse,
  StoryboardItem,
} from "src/types/experiences/storyboards";

const cleverstoryApiUrl = process.env.REACT_APP_CLEVERSTORY_API_URL;
const STORYBOARD_URL = `${cleverstoryApiUrl}/api/2.0/storyboards`;
const STORYBOARD_LIST_URL = `${cleverstoryApiUrl}/api/1.0/storyboards/list`;

export const experiencesStoryboardsApi = {
  getStoryboards: async (
    request: FetchStoryboardsRequest
  ): Promise<FetchStoryboardsResponse> => {
    const response = await axios.post(`${STORYBOARD_URL}/search`, request);
    return response.data;
  },

  cloneStoryboard: async (
    id: string,
    name: string
  ): Promise<StoryboardItem> => {
    const response = await axios.post(`${STORYBOARD_URL}/${id}/clone`, null, {
      params: { name },
    });
    return response.data;
  },

  renameStoryboard: async (
    id: string,
    name: string
  ): Promise<StoryboardItem> => {
    const response = await axios.put(`${STORYBOARD_URL}/${id}`, { name });
    return response.data;
  },

  deleteStoryboard: async (id: string): Promise<void> => {
    await axios.delete(`${STORYBOARD_URL}/${id}`);
  },

  addStoryboardToList: async (
    listId: string,
    storyboardIds: string[]
  ): Promise<void> => {
    await axios.post(`${STORYBOARD_LIST_URL}/${listId}/storyboards`, storyboardIds);
  },
};
